import React, { Component } from "react";
import BlogsContainer from "../../containers/blogs/index";
import BlogContainer from "../../containers/blogs/Blog";
import { useParams } from "react-router-dom";

const BlogsPage = () => {
  let { id } = useParams();

  return id ? <BlogContainer id={id} /> : <BlogsContainer />;
};

export default BlogsPage;
